import * as React from "react";
import { observer } from "mobx-react";
import { RacingStore } from "../../data/store";
// imported only for typings
// these are passed to the component from index.ts
import { BaseDict } from "./dict";
import { RacingRegionSwitcherData } from "./data";

// external components
import * as CMP from "./components";

/*
    Setup testing tools for MobX
    uncoment the <DevTools /> at the end of the RacingRegionSwitcher component
*/
// import DevTools from "mobx-react-devtools";
// import { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from "mobx-react-devtools";
// if (process.env.NODE_ENV === "development") {
//     setLogEnabled(true);
//     setUpdatesEnabled(true);
//     setGraphEnabled(true);
// }

@observer
export class RacingRegionSwitcher extends React.Component<{
    dataProvider: RacingRegionSwitcherData,
    dict: BaseDict,
}, {
    dataProvider: RacingRegionSwitcherData
    selected: number
}> {
    dict: BaseDict
    racingStore: RacingStore;
    /* istanbul ignore next */
    constructor(props) {
        super(props);
        /* istanbul ignore next */
        this.dict = this.props.dict;
        /* istanbul ignore next */
        this.state = {
            dataProvider: this.props.dataProvider,
            selected: 1
        }
        this.racingStore = RacingStore.getInstance;
    }

    /* istanbul ignore next */
    handleClick(value: number) {
        this.racingStore.setRegion(value);
    }

    /* istanbul ignore next */
    render() {

        return (
            <div className="racing-region-selector">
                {
                    this.state.dataProvider.regions.map((item) => {
                        return <CMP.Region
                            key={item.name}
                            label={item.name}
                            selected={this.racingStore.regionId === item.id ? true : false}
                            handler={() => this.handleClick(item.id)}
                        />
                    })
                }
            </div>)
    }
}
